import { render, staticRenderFns } from "./MessageCardCelebrationPreview.vue?vue&type=template&id=5f90a808&scoped=true&"
import script from "./MessageCardCelebrationPreview.vue?vue&type=script&lang=ts&"
export * from "./MessageCardCelebrationPreview.vue?vue&type=script&lang=ts&"
import style0 from "./MessageCardCelebrationPreview.vue?vue&type=style&index=0&id=5f90a808&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f90a808",
  null
  
)

export default component.exports